import { render, staticRenderFns } from "./IFrameBase.vue?vue&type=template&id=6fea4b85&"
import script from "./IFrameBase.vue?vue&type=script&lang=js&"
export * from "./IFrameBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports